import React from 'react';

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renameUser() {
    let new_display_name = prompt(
      'Zmeniť meno používateľa ' + this.props.user.display_name + '?',
      this.props.user.display_name,
    );
    if (new_display_name && new_display_name.length) {
      this.props.renameUser(this.props.user._id, new_display_name);
    }
  }

  toggleAdmin() {
    if (
      window.confirm(
        'Zmeniť admin práva používateľa ' + this.props.user.display_name + '?',
      )
    ) {
      this.props.toggleAdmin(this.props.user._id, !this.props.user.is_admin);
    }
  }

  removeUser() {
    if (
      window.confirm(
        'Odobrať používateľa ' + this.props.user.display_name + '?',
      )
    ) {
      this.props.removeUser(this.props.user._id);
    }
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.logged_user._id === this.props.user._id ? (
            <span>
              <i className="fa fa-user text-info" />&nbsp;
            </span>
          ) : (
            ''
          )}
          <strong>{this.props.user.display_name}</strong>
          &nbsp;
          <a
            href="javascript:void(0);"
            onClick={this.renameUser.bind(this)}
            title="Zmeniť meno používateľa?"
          >
            <i className="fa fa-cog" />
          </a>
          {this.props.user.id}
        </td>
        <td className="text-center">
          <a href="javascript:void(0);" onClick={this.toggleAdmin.bind(this)}>
            {this.props.user.is_admin ? (
              <i className="fa fa-check" />
            ) : (
              <i className="fa fa-remove" />
            )}
          </a>
        </td>
        <td className="text-right">
          <a href="javascript:void(0);" onClick={this.removeUser.bind(this)}>
            <i className="fa fa-trash" />
            &nbsp;Odobrať používateľa
          </a>
        </td>
      </tr>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/js/app/admin/User.jsx